import React from "react";
import ProductScreen from "../../components/ProductScreen";

export default function Payments() {
  return (
    <ProductScreen
      heroImageSrc="/product-heroes/payments.png"
      eyebrow="Products / Payments"
      title="Payments"
      accent="#6d33ff"
      description="Collect, reconcile and manage payments."
      bullets={[
        "Collections, reconciliation, and payout operations in one flow.",
        "Built for subscriptions, invoices, and payment tracking.",
        "Designed for secure financial operations at scale.",
      ]}
      features={[
        { title: "Collections", text: "Bring together payment intake from multiple channels." },
        { title: "Reconciliation", text: "Match transactions and simplify settlement workflows." },
        { title: "Payouts", text: "Manage downstream disbursements with confidence." },
      ]}
      ctaLabel="Explore Payments"
      summaryKicker="Payments Layer"
      summaryTitle="Keep collections, reconciliation, and payouts moving in one rhythm."
      summaryText="Payments is designed for teams that need reliable financial operations without stitching together disconnected tools."
    />
  );
}
